import { Link } from "react-router-dom";
import { Briefcase, UserRound } from "lucide-react";
import { RegistrationRoleCard } from "../components/RegistrationRoleCard";
import { Layout } from "../layout/Layout";

export function Registro() {
	return (
		<Layout>
			<div className='flex min-h-[calc(100vh-120px)] items-center justify-center bg-slate-100 px-4 py-10'>
				<div className='mx-auto w-full max-w-3xl rounded-3xl bg-white px-6 py-10 shadow-xl sm:px-10'>
					<div className='space-y-2 text-center'>
						<p className='text-sm font-semibold text-slate-500'>Registro</p>
						<h1 className='text-xl font-semibold text-slate-900 sm:text-2xl'>
							¿Cómo deseas usar Servix?
						</h1>
					</div>

					<div className='mt-8 grid gap-6 sm:grid-cols-2'>
						<RegistrationRoleCard
							title='Cliente'
							description='Busco servicios profesionales para mis necesidades'
							icon={<UserRound />}
							to='/registro/cliente'
						/>
						<RegistrationRoleCard
							title='Proveedor'
							description='Quiero ofrecer mis servicios profesionales'
							icon={<Briefcase />}
							to='/registro/proveedor'
						/>
					</div>

					<div className='mt-8 space-y-2 text-center text-xs text-slate-500'>
						<p>
							Al registrarte, aceptas nuestros{" "}
							<Link
								className='text-primary hover:text-primary-hover'
								to='/terminos-condiciones'
							>
								Términos de Servicio
							</Link>{" "}
							y{" "}
							<Link
								className='text-primary hover:text-primary-hover'
								to='/politicas'
							>
								Política de Privacidad
							</Link>
						</p>
						<p>
							¿Tienes cuenta?{" "}
							<Link
								className='text-primary hover:text-primary-hover'
								to='/login'
							>
								Ingresa aquí
							</Link>
						</p>
					</div>
				</div>
			</div>
		</Layout>
	);
}
